import * as React from "react";
function SvgHspReply(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#5a5a5a"
        d="M10 6.3c6.5 0 10 4.8 10 12.5-1.9-3-3.4-5-10-5v5L0 10l10-8.8v5.1z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHspReply);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
